import { BiChatContextType, BrandInsightChatContexts, ChatContextType } from '../enums';
import type { BrandInsightsPageContext } from '../types';

export function isEverythingContext(context: BrandInsightsPageContext.Item): boolean {
  if (context.type === ChatContextType.Global) return true;

  if (context.type === ChatContextType.Agent && context.data.identifier === BiChatContextType.Global) return true;

  return false;
}

export function isProjectContext(context: BrandInsightsPageContext.Item): boolean {
  if (context.type === ChatContextType.Project) return true;

  if (context.type === ChatContextType.Agent && context.data.identifier === BiChatContextType.Project) return true;

  return false;
}

export function isFolderContext(context: BrandInsightsPageContext.Item): boolean {
  if (context.type === ChatContextType.Agent && context.data.identifier === BiChatContextType.Folder) return true;
  if (context.type === ChatContextType.Folder) return true;

  return false;
}

export function isBrandContext(context: BrandInsightsPageContext.Item): boolean {
  if (context.type === ChatContextType.Agent && context.data.identifier === BiChatContextType.Brand) return true;
  if (context.type === ChatContextType.Brand) return true;

  return false;
}

export function isTranscriptContext(context: BrandInsightsPageContext.Item): boolean {
  if (context.type === ChatContextType.Agent && context.data.identifier === BiChatContextType.Transcript) return true;
  if (context.type === ChatContextType.Transcript) return true;
  return false;
}

export function isDocumentContext(context: BrandInsightsPageContext.Item): boolean {
  if (context.type === ChatContextType.Agent && context.data.identifier === BiChatContextType.Document) return true;
  if (context.type === ChatContextType.Document) return true;
  return false;
}

export function isBrandInsightsContext(context: BrandInsightsPageContext.Item): boolean {
  return context.type === ChatContextType.Agent &&
    BrandInsightChatContexts.includes(context.data.identifier);
}

export function extractBrandInsightsIds(context: BrandInsightsPageContext.Item) {

  let brandId: number | undefined = undefined;
  let folderId: number | undefined = undefined;
  let projectId: number | undefined = undefined;
  const fileId: number | undefined = undefined;
  const transcriptId: number | undefined = undefined;

  if (context.type === ChatContextType.Brand) {
    brandId = context.data.brandId;
  } else if (context.type === ChatContextType.Folder) {
    folderId = context.data.folderId;
  } else if (context.type === ChatContextType.Project) {
    projectId = context.data.projectId;
  } else if (context.type === ChatContextType.Agent) {
    if (context.data.identifier === BiChatContextType.Brand) {
      brandId = context.data.subject?.id as number;
    } else if (context.data.identifier === BiChatContextType.Folder) {
      folderId = context.data.subject?.id as number;
    } else if (context.data.identifier === BiChatContextType.Project) {
      projectId = context.data.subject?.id as number;
    }
  }

  return {
    brandId,
    folderId,
    projectId,
    fileId,
    transcriptId,
  };
}